module.exports = __webpack_public_path__ + "img/m-partner.ad4fac8a.jpeg";